import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import 'animate.css';
import { useProjectTracker } from "src/useProjectTracker";
import '../styles/contact.css';
import itchIcon from "../assets/img/itchio-textless-white.svg";
import { GitHub, LinkedIn, Twitter } from "@mui/icons-material";

export const Contact = () => {
  useProjectTracker();

  const formInitialDetails = {
    email: '',
    subject: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const { subject, message } = formDetails;
    const mailtoLink = `mailto:contact@lucascoutinho.dev?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
    window.location.href = mailtoLink;
  };

  return (
    <section className="contact" id="connect">
      <div className="contact-container">
        <div className="contact-flex">
          <h2>Let's connect<span style={{ color: "var(--color-accent)", transition: "color 0.2s ease-in-out" }}>.</span></h2>
          <h4>Always open to great conversations and opportunities—reach out! 🚀</h4>
          <div className="contact-links-container">
            <Row size={6} md={6}>
              <Col size={12} lg={12} md={12} sm={12} className="contact-links-col">
                <a href="https://linkedin.com/in/lucasctnh/" target="_blank" rel="noreferrer" className="contact-banner">
                  <div className="contact-banner-icon">
                    <LinkedIn />
                  </div>
                  <div className="contact-banner-text">
                    <p>Find me on</p>
                    <p className="contact-banner-link">linkedin.com/in/lucasctnh</p>
                  </div>
                </a>

                <a href="https://github.com/lucasctnh" target="_blank" rel="noreferrer" className="contact-banner">
                  <div className="contact-banner-icon">
                    <GitHub />
                  </div>
                  <div className="contact-banner-text">
                    <p>Explore my code at</p>
                    <p className="contact-banner-link">github.com/lucasctnh</p>
                  </div>
                </a>

                {/* <a href="mailto:contact@lucascoutinho.dev" target="_blank" rel="noreferrer" className="contact-banner">
                  <div className="contact-banner-icon">
                    <Mail />
                  </div>
                  <div className="contact-banner-text">
                    <p>Mail me at</p>
                    <p className="contact-banner-link">contact@lucascoutinho.dev</p>
                  </div>
                </a> */}
              </Col>
            </Row>
            <Row size={6} md={6}>
              <Col size={12} lg={12} md={12} sm={12} className="contact-links-col">
                <a href="https://lucasctnh.itch.io/" target="_blank" rel="noreferrer" className="contact-banner">
                  <div className="contact-banner-icon">
                    <img src={itchIcon} alt="Itch.io" />
                  </div>
                  <div className="contact-banner-text">
                    <p>Check out my games in</p>
                    <p className="contact-banner-link">lucasctnh.itch.io/</p>
                  </div>
                </a>

                <a href="https://x.com/lucas_ctnh" target="_blank" rel="noreferrer" className="contact-banner">
                  <div className="contact-banner-icon">
                    <Twitter />
                  </div>
                  <div className="contact-banner-text">
                    <p>Follow me on</p>
                    <p className="contact-banner-link">twitter.com/lucas_ctnh</p>
                  </div>
                </a>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div className="contact-container-body">
        <div className="contact-flex">
          <h3>Send me an email</h3>
          <form onSubmit={handleSubmit}>
            <Row>
              <Col size={12} sm={12} className="px-1">
                <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} />
              </Col>
              <Col size={12} sm={12} className="px-1">
                <input type="text" value={formDetails.subject} placeholder="Subject" onChange={(e) => onFormUpdate('subject', e.target.value)} />
              </Col>
              <Col size={12} className="px-1">
                <textarea rows={6} value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                <button type="submit">
                  <span>Send message</span>
                </button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </section>
  )
}
